import React, { useEffect, useState } from "react";
import { notification } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { changeStatus } from "../../../controllers/V1/pullOutRequestController";
import LoadingEffect from "../../../components/Loading/LoadingEffect";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { faArrowLeft, faCheckCircle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { usePermissions } from "../../../controllers/PermissionContext";
const PullOutRequestView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [ errors, setError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [ADDEDITDATA, setAddEditData] = useState(location?.state ||{});
  const PERMISSION = usePermissions("userPullOutRequest");
  const handleChange = async (e) => {
    try {
      const {name, value} = e.target;
      setAddEditData((pre)=>({
        ...pre,
        [name] : value
      }));
    } catch (error) {
      
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      setError({});
      const form = new FormData(e.target);
      let error = false;
      let errorMessage = "";
      if(!form.get('edit_id')){
        error = true;
        errorMessage = "Request not found! Please try again.";
      }

      if(error === true){
        notification.open({
          message: "Oops!.",
          description: `${errorMessage}`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
          duration: 2,
        });
      } else{
        const option = {
          id                              : form.get('edit_id'), 
          remarks                         : form.get('admin_remarks') || "", 
          status                          : "Completed"
        }
        let res = await changeStatus(option);
        if(res.status === true){
          notification.open({
            message: "Success.",
            description: `Request completed successfully.`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle} />,
            duration: 2,
          });
          navigate("/request/pull-out-list");
        } else {
          notification.open({
            message: "Oops!.",
            description: `No data found.`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
      console.log("error : ", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  }

  const handleReject = async () => {
    try {
      setIsLoading(true);
      if(!ADDEDITDATA?.admin_remarks || ADDEDITDATA?.admin_remarks === ""){
        notification.open({
          message: "Oops!.",
          description: `Remarks is required`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
          duration: 2,
        });
      } else if(!ADDEDITDATA?._id){
        notification.open({
          message: "Oops!.",
          description: `Please try again.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
          duration: 2,
        });
      } else{
        const options = {
          id : ADDEDITDATA?._id,
          remarks : ADDEDITDATA?.admin_remarks,
          status : "Rejected"
        }
        let res = await changeStatus(options);
        if(res.status === true){
          notification.open({
            message: "Success.",
            description: `Request rejected successfully.`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle} />,
            duration: 2,
          });
          navigate("/request/pull-out-list");
        } else {
          notification.open({
            message: "Oops!.",
            description: `No data found.`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
      notification.open({
        message: "Oops!.",
        description: `Please go back and try again.`,
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        duration: 2,
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  }

  // useEffect(()=>{
  //   setAddEditData(edit_data);
  // },[edit_data])


  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading"> Pull Out Request Details </h5>
          </React.Fragment>
          <Link to={"/request/pull-out-list"}>
            <React.Fragment>
              <button type="button" className="btn btn-secondary"> <FontAwesomeIcon icon={faArrowLeft}/> Back </button>
            </React.Fragment>
          </Link>
        </div>

        
          <div className="card shadow mb-4 dataBase_table_Add_Data">
            <div
            className="pull-out-add-edit-border-wrap"
            style={{
              border: "12px solid #ef9a9a",
              borderRadius: "12px",
              boxSizing: "border-box",
              overflow: "hidden",
            }}
          >
            <div className="card-body">
            <div className="responsive">
              <form className="categories_open_popup_form" onSubmit={handleSubmit} >
                <input type="hidden" name="edit_id" id="edit_id" value={ADDEDITDATA?._id}/>
                <div className="form-group row">
                  
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label for="title" className="all_lable_for_vendor_dashbaord" >
                      <span style={{color:"red"}}>*</span>Store Name :
                    </label>
                    <input name="store_name" id="store_name" placeholder="Enter Store Name" disabled value={ADDEDITDATA?.users_id?.store_name} className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label for="title" className="all_lable_for_vendor_dashbaord" >
                      <span style={{color:"red"}}>*</span>Name :
                    </label>
                    <input name="name" id="name" placeholder="Enter Name" disabled value={ADDEDITDATA?.users_id?.users_name} className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label for="pos_number" className="all_lable_for_vendor_dashbaord" >
                      <span style={{color:"red"}}>*</span>POS number
                    </label> 
                    <input type="text" name="pos_number" id="pos_number" value={ADDEDITDATA?.users_id?.pos_number} disabled className="form-control"/>
                  </div>

                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label for="bind_user_type" className="all_lable_for_vendor_dashbaord" >
                      <span style={{color:"red"}}>*</span>Bind User Type
                    </label> 
                    <input type="text" name="bind_user_type" id="bind_user_type" value={ADDEDITDATA?.users_id?.users_type} disabled className="form-control"/>
                  </div>

                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label for="country_code" className="all_lable_for_vendor_dashbaord" >
                      <span style={{color:"red"}}>*</span>Phone
                    </label> 
                    <input type="number" name="mobile" id="mobile" value={ADDEDITDATA?.users_id?.users_mobile} disabled className="form-control " placeholder="Enter Phone Number"/>
                  </div>

                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label for="pos_condition" className="all_lable_for_vendor_dashbaord" >
                      <span style={{color:"red"}}>*</span>POS Condition :
                    </label> 
                    <input type="text" name="pos_condition" id="pos_condition" value={ADDEDITDATA?.pos_condition} disabled className="form-control " placeholder="Enter POS Condition"/>
                  </div>

                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label for="bind_user_type" className="all_lable_for_vendor_dashbaord" >
                      <span style={{color:"red"}}>*</span>Bind User Type
                    </label> 
                    <input type="text" name="bind_user_type" id="bind_user_type" value={ADDEDITDATA?.bind_person_id?.users_type} disabled className="form-control " placeholder="Enter User Type"/>
                  </div>

                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label for="bind_user_name" className="all_lable_for_vendor_dashbaord" >
                      <span style={{color:"red"}}>*</span>Bind User Name
                    </label> 
                    <input type="text" name="bind_user_name" id="bind_user_name" value={ADDEDITDATA?.bind_person_id?.users_name} disabled className="form-control " placeholder="Enter Bind User Name"/>
                  </div>

                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label for="availableArabianPoints" className="all_lable_for_vendor_dashbaord" >
                      <span style={{color:"red"}}>*</span>Total U-Points :
                    </label> 
                    <input type="text" name="availableArabianPoints" id="availableArabianPoints" value={ADDEDITDATA?.users_id?.availableArabianPoints} disabled className="form-control " placeholder="Enter POS Condition"/>
                  </div>

                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label for="due_amount" className="all_lable_for_vendor_dashbaord" >
                      <span style={{color:"red"}}>*</span>Total Due Amount :
                    </label> 
                    <input type="text" name="due_amount" id="due_amount" value={ADDEDITDATA?.users_id?.due_amount} disabled className="form-control " placeholder="Enter POS Condition"/>
                  </div>

                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label for="old_due_amount" className="all_lable_for_vendor_dashbaord" >
                      <span style={{color:"red"}}>*</span>Total Old Due Amount :
                    </label> 
                    <input type="text" name="old_due_amount" id="old_due_amount" value={ADDEDITDATA?.users_id?.old_due_amount} disabled className="form-control " placeholder="Enter POS Condition"/>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="target_collection" className="all_lable_for_vendor_dashbaord" >
                      <span style={{color:"red"}}>*</span>Total Target Collection :
                    </label> 
                    <input type="text" name="target_collection" id="target_collection" value={ADDEDITDATA?.users_id?.target_collection} disabled className="form-control " placeholder="Enter POS Condition"/>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="total_collection" className="all_lable_for_vendor_dashbaord" >
                      <span style={{color:"red"}}>*</span>Total Collected :
                    </label> 
                    <input type="text" name="total_collection" id="total_collection" value={ADDEDITDATA?.users_id?.total_collection} disabled className="form-control " placeholder="Enter POS Condition"/>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="total_settlement" className="all_lable_for_vendor_dashbaord" >
                      <span style={{color:"red"}}>*</span>Total Target Settlement :
                    </label> 
                    <input type="text" name="target_settlement" id="target_settlement" value={ADDEDITDATA?.users_id?.target_settlement} disabled className="form-control " placeholder="Enter POS Condition"/>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="total_settlement" className="all_lable_for_vendor_dashbaord" >
                      <span style={{color:"red"}}>*</span>Total Settlement :
                    </label> 
                    <input type="text" name="total_settlement" id="total_settlement" value={ADDEDITDATA?.users_id?.total_settlement} disabled className="form-control " placeholder="Enter POS Condition"/>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="total_settlement" className="all_lable_for_vendor_dashbaord" >
                      <span style={{color:"red"}}>*</span>POS Device ID :
                    </label> 
                    <input type="text" name="pos_device_id" id="pos_device_id" value={ADDEDITDATA?.users_id?.pos_device_id} disabled className="form-control " placeholder="POS Device ID"/>
                  </div>

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label for="reason" className="all_lable_for_vendor_dashbaord" >Reason </label> 
                    <textarea name="reason" id="reason" className="form-control" readOnly >{ADDEDITDATA?.reason}</textarea>
                  </div>
                  
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label for="remarks" className="all_lable_for_vendor_dashbaord" >SIM Details/User's Remarks </label> 
                    <textarea name="remarks" id="remarks" className="form-control" readOnly >{ADDEDITDATA?.remarks}</textarea>
                  </div>

                  {ADDEDITDATA?.account_status === "Completed" && (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label for="admin_remarks" className="all_lable_for_vendor_dashbaord" >Accounts Remarks </label> 
                      <textarea disabled className="form-control">{ADDEDITDATA?.account_remarks || "N/A"}</textarea>
                    </div>
                  )}

                  {ADDEDITDATA?.deployment_status === "Completed" && (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label for="admin_remarks" className="all_lable_for_vendor_dashbaord" >Deployment Remarks </label> 
                      <textarea disabled className="form-control">{ADDEDITDATA?.deployment_remarks || "N/A"}</textarea>
                    </div>
                  )}

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label for="admin_remarks" className="all_lable_for_vendor_dashbaord" >Remarks </label> 
                    <textarea name="admin_remarks" id="admin_remarks" className="form-control" onChange={handleChange}>{ADDEDITDATA?.admin_remarks}</textarea>
                  </div>
                  

                  {
                    ADDEDITDATA?.status === "Pending" && (
                    PERMISSION?.complete === 'Y' || 
                    PERMISSION?.reject === 'Y' || 
                    PERMISSION?.fullAccess === 'Y') 
                  ? (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      {(
                        (
                          PERMISSION?.deployment_chnage_ststus === 'Y' &&
                          ADDEDITDATA?.deployment_status === "Pending" &&
                          ADDEDITDATA?.account_status === "Pending" &&
                          ADDEDITDATA?.bdm_status === "Pending" &&
                          ADDEDITDATA?.status === "Pending"

                        ) || (
                          PERMISSION?.account_chnage_ststus === 'Y' &&
                          ADDEDITDATA?.deployment_status === "Completed" &&
                          ADDEDITDATA?.account_status === "Pending" &&
                          ADDEDITDATA?.bdm_status === "Pending" &&
                          ADDEDITDATA?.status === "Pending"
                        ) || (
                          PERMISSION?.bdm_chnage_ststus === 'Y' && 
                          ADDEDITDATA?.deployment_status === "Completed" &&
                          ADDEDITDATA?.account_status === "Completed" &&
                          ADDEDITDATA?.bdm_status === "Pending" &&
                          ADDEDITDATA?.status === "Pending"
                        ) || PERMISSION?.fullAccess === 'Y') && (
                        <div className="inventory_open_popup_action_btn">
                          {(PERMISSION?.complete === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                          <button type="submit" className="btn btn-success categories_cancel_button" style={{width : "25%"}} > Complete </button>
                          )}
                          {(PERMISSION?.reject === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                            <button type="button" className="btn btn-danger" style={{width : "25%"}} onClick={handleReject} > Reject </button>
                          )}
                        </div>
                        )}

                    </div>
                  ):(
                    ADDEDITDATA?.status !== "Pending" && (
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="inventory_open_popup_action_btn">
                          <span className="btn btn-danger" > {`Request is ${ADDEDITDATA?.status}`} </span>
                        </div>
                      </div>
                    )
                  )}

                </div>
              </form>
            </div>
          </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
    
  );
};

export default PullOutRequestView;
